export function formatCookieMaxAgeSeconds(cookieMaxAgeSeconds) {
    if (cookieMaxAgeSeconds === null) {
      return null;
    } else {
      const secondsInADay = 86400; // 60 seconden * 60 minuten * 24 uur
      return Math.ceil(cookieMaxAgeSeconds / secondsInADay);
    }
  }